import { Recipe } from '../../entities/recipes/recipes.types';

export type CreateRationPayload = {
  displayName: string;
  description: string;
  density: number;
  adjOnDM: boolean;
  notInUse: boolean;
  autoAdjWater: boolean;
  amountDays: number[];
  premix?: boolean;
  percEntryMethod: number;
  ingredients: (MixerDataInIngredient & {
    ingredientId: number;
    amounts: number[];
    dryAmounts: number[];
    loadPercs: number[];
    dryLoadPercs: number[];
  })[];
  amounts?: number[];
  dryAmounts?: number[];
  dryMatterPercs?: number[];
  animalPrices?: number[];
  targetDMPerc: number;
  baseRationId?: string;
  baseRationPerc?: number;
  rationTypeCode?: number;
  baseRationAmounts?: number[];
  baseRationDryAmounts?: number[];
  baseRationLoadPercs?: number[];
  baseRationDryLoadPercs?: number[];
  premixAllowDMChangeAtMixer?: boolean;
  finalDateBeforeTransition?: string;
};

export enum SourceType {
  dryMatter = 'dryMatter',
  actualLoad = 'actualLoad',
  mixer = 'mixer',
}

export type IngredientInCreation = {
  id: string;
  ownId?: string;
  uuid: string;
  mixerData: MixerDataInIngredient;
  dryMatterPerc: number;
  refusalSubstitute?: boolean;
  refusal?: boolean;
  toleranceMotion: number;
  toleranceWeight: number;
};

export type IngredientInRecipeCreation = IngredientInCreation & {
  actualLoad: number[];
  dryMatter: number[];
  actualLoadTotalPercentage: number[];
  dryMatterTotalPercentage: number[];
};

export type IngredientInPremixCreation = IngredientInCreation & {
  actualLoad: number;
  dryMatter: number;
  actualLoadTotalPercentage: number;
  dryMatterTotalPercentage: number;
};

export type PreviewRationCreation = CreateRationPayload & {
  finalAmount: number;
  finalDryMatterPerc: number;
  finalPricePerCow: number;
  finalPricePerWt: number;
  roughageDMPercs: number[];
  byproductDMPercs: number[];
  concentrateDMPercs: number[];
  transitionAllowed: boolean;
};

export interface MixerDataInIngredient {
  mixingValue?: number;
  mixingTypeCode?: number;
  mixingStartTypeCode?: number;
  mixingStartValue?: number;
  mixingRPM?: number;
}

export interface ToleranceData {
  toleranceMotion: number;
  toleranceWeight: number;
}

export interface AddIngredientPayload {
  id: string;
  ownId?: string;
  actualLoad?: number;
  dryMatter?: number;
  actualLoadPercentage?: number;
  dryMatterPercentage?: number;
  listId?: string;
  refusal?: boolean;
  mixerData?: MixerDataInIngredient;
  isOverridable?: boolean;
  dryMatterPerc?: number;
  refusalSubstitute?: boolean;
  toleranceMotion: number;
  toleranceWeight: number;
}

export type BaseRationData = {
  ration: Recipe | null | undefined;
  percentage: number;
  actualLoad: number;
  dryMatter: number;
  actualLoadTotalPercentage: number;
  dryMatterTotalPercentage: number;
  ingredients: IngredientInRecipeCreation[];
};

export enum EntryMethodsKeys {
  WEIGHT = 1,
  PERCENTAGE = 2,
}

export enum TargetWeights {
  DRY = 1,
  ACTUAL = 2,
}

export interface ChangeIngredientPayload extends IngredientInRecipeCreation {
  uuid: string;
  id: string;
  ownId?: string;
  dryMatterPerc: number;
  refusalSubstitute?: boolean;
}
